import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { getAssetURL } from 'lib/utility/GetAssetUrl'
import variables from 'assets/styles/scss/shared/_variables.module.scss'

// Define a type for the props
interface CardEmptyProps {
  sourceStatus?: string
}

const StyledNoData = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CardEmpty = ({ sourceStatus }: CardEmptyProps) => {
  const { t } = useTranslation()

  const message =
    sourceStatus === 'disableAnalysis'
      ? 'This feature is currently unavailable on your site'
      : sourceStatus === 'disableSentiment'
      ? 'Enable sentiment to view results'
      : t('common.noDataToDisplay')

  return (
    <StyledNoData>
      <Box component="img" src={getAssetURL('/empty/noData.svg')} alt="" />
      <Typography
        variant="subtitle2"
        fontWeight="400"
        color={variables['grey-22']}
        padding={1}
        width="max-content"
      >
        {message}
      </Typography>
    </StyledNoData>
  )
}

export { CardEmpty }
